export default {
  data() {
    return {
      course: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    courses() {
      return this.$store.state.courses.coursesList;
    },
  },
  methods: {
    goToCourse(id) {
      this.$router.push(`/course/${id}`);
    },
  },
  watch: {
    'user.profile_id': {
      immediate: true,
      handler(profileId) {
        if (profileId) {
          this.$store.dispatch('courses/GetCoursesList', profileId);
        }
      },
    },
  },
};
